module.exports = __webpack_public_path__ + "static/media/fifteen.7e084556.jpg";